import {
	request
} from '@/js_sdk/request.utils.js';


export function cfgIndex() {
	return request({
		url: '/api/index/getConfigForFront',
		method: 'POST'
	})
}

// 注销
export function deleteLoginFn(data={}) {
	return request({
		url: '/api/index/deleteLogin',
		method: 'POST',
		data
	})
}

// 渠道埋点
export function channeladd(data={}) {
	return request({
		url: '/bury2/add',
		method: 'POST',
		data
	})
}